import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LangSrcService} from '../../services/lang-src/lang-src.service';
import {LangTgtService} from '../../services/lang-tgt/lang-tgt.service';
import {ConfigService} from '../../services/config/config.service';

@Component({
  selector: 'app-minor-restriction',
  templateUrl: './minor-restriction.component.html',
  styleUrls: ['./minor-restriction.component.scss']
})
export class MinorRestrictionComponent implements OnInit {

  loader = true;

  @Input() name: string | null = null;

  constructor(
    private activeModal: NgbActiveModal,
    public langSrcSrv: LangSrcService,
    public langTgtSrv: LangTgtService,
    public configSrv: ConfigService
  ) { }

  async ngOnInit() {
    this.loader = false;
  }

  close() {
    this.activeModal.close();
  }

}
